import * as React from 'react';
import { Link } from 'gatsby';
import { Helmet } from 'react-helmet';
import Layout from '../components/layout';

const EugeniText = () => {
  return (
    <Layout
      title='El cos com a paisatge, Eugeni Prieto'
      description="Text d'Eugeni Prieto. Presentació del projecte fotogràfic Cos - Paisatge. El retrat, com gènere fotogràfic, sempre m'ha interessat. És una eina, al meu entendre, de coneixement i divulgació capaç d'emmagatzemar una gran quantitat d'informació, tant física com psicològica, sobre la persona a qui es retrata."
      path='/eugeni-prieto-text'
      ogType='article'
    >
      <>
        <Helmet>
          <meta property='og:article:author' content='Eugeni Prieto' />
          <meta
            property='og:article:tag'
            content='art, fotografia, cos, paisatge'
          />
        </Helmet>
        <h2 className='textHeading'>El cos com a paisatge</h2>
        <p className='textParagraph'>
          El retrat, com gènere fotogràfic, sempre m'ha interessat. És una eina,
          al meu entendre, de coneixement i divulgació capaç d'emmagatzemar una
          gran quantitat d'informació, tant física com psicològica, sobre la
          persona a qui es retrata.
        </p>
        <p className='textParagraph'>
          Quan fotografio els rostres opto per no donar més dades que els que es
          desprenen del propi model, prescindint de qualsevol element
          superficial que pugui desviar l'atenció de l'espectador, en un intent
          de fixar-la exclusivament en la humanitat del personatge.
        </p>
        <p className='textParagraph'>
          Però hi ha una altra manera d'apropar-se al coneixement de la persona
          retratada i és a través d'allò que Paul Valéry va deixar escrit en
          L'idea fixa (1931): "La pell és el més profund que hi ha en l'home".
          La pell, per tant, es pot considerar, si sabem interpretar la seva
          cartografia i els seus signes (arrugues, tatuatges, peques, grans,
          etc.) com una superfície on llegir el que ha escrit el temps. Des
          d'aquest punt de vista, la pell, constitueix un mitjà per obtenir
          informacions que poden anar més enllà de la simple evidència externa,
          en línia amb el que el psicòleg francès Didier Azieu va dir en el seu
          treball "Le moi-peau" (1974 ): la psicologia de la pell, el jo
          exterior en contrast amb aquell jo interior del qual parlava Sigmund
          Freud.
        </p>
        <p className='textParagraph'>
          D'una manera o altra, la interacció entre el cos i el seu entorn, el
          paisatge pel qual es mou, és més que evident. L'un modifica a l'altre
          en una relació dinàmica. Podríem expressar, en paraules de
          l'arquitecta Andrea Saltzman, que el paisatge és interpretable com una
          extensió del cos, i viceversa, el cos com una extensió del paisatge
          (El cos dissenyat, 2004).
        </p>
        <p className='textParagraph'>
          El meu recorregut visual per diversos cossos humans, els meus
          paisatges particulars, constitueixen una geografia humana de
          característiques específiques, a l'hora de conformar el món fotogràfic
          en què centro el meu treball dels últims temps.
        </p>
        <p className='textFirma'>Eugeni Prieto</p>
        <div className='textLinks'>
          <div className='textLink'>
            <Link to='/cv-eugeni-prieto'>CV</Link>
          </div>
          {/* <div className='textLink'>
            <Link to='/'>Fotografies</Link>
          </div> */}
        </div>
      </>
    </Layout>
  );
};

export default EugeniText;
